export default class FormValidator {
  constructor(formData) {
    this.formData = formData;
    this.valid = true;
  }

  validate(specificField = null) {
    this.valid = true;

    const validation = {...this.formData.validation};
    const fields = Object.keys(validation);

    if (fields.length === 0) {
      return; // break validation
    }

    for (const fieldKey of fields) {
      if (specificField !== null && specificField !== fieldKey) {
        continue;
      }

      const value = this.formData[fieldKey];

      if (
        typeof validation[fieldKey] !== "object" ||
        typeof validation[fieldKey].rules !== "object"
      ) {
        continue;
      }

      // Required to create new instance for Vue to notice changes
      const fieldValidation = {...validation[fieldKey]};

      const rules = fieldValidation.rules;
      fieldValidation.errors = [];
      for (const ruleKey of Object.keys(fieldValidation.rules)) {
        const rule = rules[ruleKey];
        const ruleResult = rule(value);

        if (ruleResult !== null) {
          this.valid = false;

          fieldValidation.errors.push(this.formData.trans(ruleResult));
        }

        fieldValidation.isSubmitted = specificField === null;
        fieldValidation.isTouched = specificField !== null;
      }

      validation[fieldKey] = fieldValidation;
    }

    this.formData.validation = validation;
  }

  isValid(field = null) {
    this.validate(field);

    return this.valid === true
      && this.formData.recaptcha.isVerified === true;
  }
}
